import jwt_decode from 'jwt-decode';
import _ from 'lodash';
export default function getAcsTokenDetails() {
  const acsToken = localStorage.getItem('acsToken');
  const decodedData = acsToken ? jwt_decode(acsToken) : '';
  return _.get(decodedData, 'skypeid', '');
}
